import { get, post, remove } from './api';
import routes from './end-points';

export const adminMembershipApi = {
  initUserMemberships: (userId) => get(routes.admin.memberships.initUserMemberships(userId)),
  initSaveMembership: (userId) => get(routes.admin.memberships.initSaveMembership(userId)),
  deleteMembership: (userId) => remove(routes.admin.memberships.deleteMembership(userId)),
  saveMembership: (dto) => post(routes.admin.memberships.saveMembership, dto),
};
